import { isLifeCycleEventExists } from '../../../utils';

/**
 * Custom hook for handling analytics and tracking events
 * @param {Object} params - Hook parameters
 * @param {string} params.itemId - Current item ID
 * @param {Object} params.parent - Parent data from impressions
 * @returns {Object} Event handlers for analytics
 */
export const useSwatchAnalytics = ({ itemId, parent }) => {
  // Remove useCallback - this is a simple event handler
  const handleOptionsLinkClick = (_event, action = null) => {
    const productMiniSwatchEventData = {
      podAction: action || 'more options link',
      podAnchorSku: itemId,
      target: '',
      parent
    };

    if (isLifeCycleEventExists()) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('product-pod-v7.click', productMiniSwatchEventData);
    }
  };

  return {
    handleOptionsLinkClick
  };
};